import * as yup from 'yup'

const emptyStringToNull = <T extends string>(value: T, originalValue: T): null | T => {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null
  }
  return value
}

export const EquipmentTypesSchema = yup.object({
  powerUnitCount: yup.number().transform(emptyStringToNull).nullable(),
  trailerCount: yup.number().transform(emptyStringToNull).nullable(),
  isDryVanCapable: yup.boolean(),
  isFlatbedCapable: yup.boolean(),
  isReeferCapable: yup.boolean(),
})

export type TEquipmentTypesSchema = yup.InferType<typeof EquipmentTypesSchema>
